import { getCookie } from '@js/globalFunctions/cookieHandling'

export function applyNewLabelToAppropriateSearchItems()
{
	if( typeof plug !== 'undefined' && plug !== 'nye' && plug !== 'neue' )
	{
		const els 		    = $('.feriehus-item');
		const newString 	= ( siteID === '1' ) ? 'Ny' : 'Neu' ;
		const newEl 		= '<div class="newHouseArea"><span class="new-label">'+newString+'<div class="newHover">'+wpTranslatedStrings.terms.newHouseEsmark+'</div></span></div>';
		if( typeof els !== 'undefined' && els.length !== 0 )
		{
			for( let i = 0; i < els.length; i++ )
			{
				$(els[i]).find('.new-label').remove();
				const daysold = $(els[i]).attr('data-daysold');
				if( typeof daysold !== 'undefined' && !isNaN(daysold) && Number(daysold) <= 365 )
				{
					const currentText = $(els[i]).find('.title').first().html();
					$(els[i]).find('.title').html( newEl + currentText);
				}
			}
		}
	}
}

/**
 * Specielle regler for ankomstdatoer om hvordan deres skiftedag skal vises på de statiske ankomstdage i slut 20 / 21.
 * Da der ikke er flere af dem virker det som spil at bruge en date parser, så det er bare statisk.
 * Fjern når vi er forbi datoerne / de ikke længere er relevante.
 */
export function applySpecialDayRulesToShownSearch()
{
	const dayRules = {
		'2020-12-18': wpTranslatedStrings.weekdays.friday,
		'2020-12-20': wpTranslatedStrings.weekdays.sunday,
		'2020-12-26': wpTranslatedStrings.weekdays.sunday,
		'2020-12-27': wpTranslatedStrings.weekdays.sunday,
		'2020-12-28': wpTranslatedStrings.weekdays.monday,
		'2020-12-29': wpTranslatedStrings.weekdays.tuesday,
		'2021-12-19': wpTranslatedStrings.weekdays.sunday,
		'2021-12-20': wpTranslatedStrings.weekdays.monday,
		'2021-12-21': wpTranslatedStrings.weekdays.tuesday,
		'2021-12-22': wpTranslatedStrings.weekdays.wednesday,
		'2021-12-25': wpTranslatedStrings.weekdays.monday,
		'2021-12-27': wpTranslatedStrings.weekdays.monday,
		'2021-12-28': wpTranslatedStrings.weekdays.tuesday,
		'2021-12-29': wpTranslatedStrings.weekdays.wednesday,
		'2022-01-02': wpTranslatedStrings.weekdays.sunday,
		'2022-01-03': wpTranslatedStrings.weekdays.monday,

	};
	if($('#search-output').length !== 0)
	{
		$('#specialDateWarning').remove();
		const currentDate = $('#dateSelect').val();
		if(typeof dayRules[currentDate] !== 'undefined')
		{
			applyWeekdaysToSearchOutputs(dayRules[currentDate]);
			if(currentDate === '2020-12-26')
			{
				showSpecialDateWarning('26');
			}
			else if(currentDate === '2021-12-25')
			{
				showSpecialDateWarning('25');
			}
		}
	}
}

function showSpecialDateWarning(replaceDate){
	$('.search-top .go-left').before('<div class="searchSectionItem" id="specialDateWarning"><p style="background: #ffdd00; padding: 4px 10px !important;border-radius: 3px;">'+wpTranslatedStrings.search.specialDateWarning.replace('%d',replaceDate)+'</p></div>')
}

function applyWeekdaysToSearchOutputs(weekday)
{
	const items = $('.feriehus-item:not(.hasSpecialRulesApplied)');
	$.each(items,function(i,el){
		$(el).find('span[itemprop=checkinTime]').text(weekday);
		$(el).addClass('hasSpecialRulesApplied');
	})
}
